<h2 mat-dialog-title>
  Globaali prompt
  @if (globaaliPromptUusin()) {
    <span style="margin-left: 8px; font-size: 13px; color: #1976d2; font-family: monospace">v{{ globaaliPromptUusin().versio }}</span>
  }
</h2>

<mat-dialog-content style="min-width: 720px; max-width: 1100px">
  @if (globaaliPromptLataa()) {
    <div>
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  } @else {
    <div>
      <div class="info-block">
        <p class="info-block__title">Globaali prompti</p>
        <ul class="info-block__list">
          <li>Tämä on jokaisen testiajon system-promptin pohja. Yhdistetään kategoriaprofiilin promptin kanssa LLM-kutsussa.</li>
          <li>Mallin vastauksen rakenne on kovakoodattu palveluun ja lisätään promptin alkuun automaattisesti — älä määrittele vastausmuotoa tässä, kirjoita vain ohjeistus.</li>
          <li>Tallennukset luovat aina uuden version. Vanha versio säilyy historiassa ja voidaan palauttaa uudeksi versioksi.</li>
        </ul>
      </div>

      @if (globaaliPromptUusin()) {
        <div style="font-size: 12px; color: #666; margin-bottom: 8px">
          Aktiivinen versio: <strong>v{{ globaaliPromptUusin().versio }}</strong> — päivitetty {{ globaaliPromptUusin().paivitetty | date: 'dd.MM.yyyy HH:mm' }}
          @if (globaaliPromptUusin().paivittajaUid) {
            <span> ({{ annaPaivittajanNimi(globaaliPromptUusin().paivittajaUid) }})</span>
          }
        </div>
      }

      <mat-form-field style="width: 100%">
        <mat-label>Globaali system prompt</mat-label>
        <textarea matInput [formField]="globaaliPromptKentta" style="font-family: monospace; font-size: 12px; min-height: 400px; resize: vertical"></textarea>
      </mat-form-field>

      <div style="display: flex; gap: 8px">
        <button mat-raised-button color="primary" (click)="tallennaGlobaali()" [disabled]="globaaliPromptTallennetaan()">
          @if (globaaliPromptTallennetaan()) {
            <mat-spinner diameter="18" style="display: inline-block; margin-right: 8px"></mat-spinner>
          }
          Tallenna uusi versio
        </button>
        <button mat-button (click)="toggleGlobaaliHistoria()">
          <mat-icon>{{ naytaGlobaaliHistoria() ? 'expand_less' : 'expand_more' }}</mat-icon>
          Versiohistoria
        </button>
      </div>

      @if (naytaGlobaaliHistoria()) {
        <div style="margin-top: 16px">
          @if (globaaliPromptHistoriaLataa()) {
            <mat-spinner diameter="24"></mat-spinner>
          } @else {
            @if (globaaliPromptHistoria().length > 1) {
              <table style="width: 100%; font-size: 12px; border-collapse: collapse">
                <tr style="background: #f5f5f5">
                  <th style="text-align: left; padding: 6px">Versio</th>
                  <th style="text-align: left; padding: 6px">Päivitetty</th>
                  <th style="text-align: left; padding: 6px">Päivittäjä</th>
                  <th style="text-align: left; padding: 6px">Esikatselu</th>
                  <th style="padding: 6px"></th>
                </tr>
                @for (v of globaaliPromptHistoria(); track v.versio) {
                  <tr style="border-bottom: 1px solid #eee">
                    <td style="padding: 6px; font-family: monospace">v{{ v.versio }}</td>
                    <td style="padding: 6px">{{ v.paivitetty | date: 'dd.MM.yyyy HH:mm' }}</td>
                    <td style="padding: 6px">{{ annaPaivittajanNimi(v.paivittajaUid) }}</td>
                    <td style="padding: 6px; max-width: 400px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{ v.prompt | slice: 0 : 80 }}{{ v.prompt.length > 80 ? '…' : '' }}</td>
                    <td style="padding: 6px">
                      <button mat-button (click)="esikatseleGlobaali(v)">Näytä</button>
                      <button mat-button color="primary" (click)="palautaGlobaaliVersio(v.versio)">Palauta</button>
                    </td>
                  </tr>
                }
              </table>
            } @else {
              <p style="color: #888; font-size: 12px; margin: 0">Ei aiempia versioita.</p>
            }
          }
        </div>
      }

      @if (esikatseluVertailu()) {
        <app-prompti-versiovertailu [vertailu]="esikatseluVertailu()" (palauta)="palautaGlobaaliVersio($event)" (sulje)="suljeEsikatseluGlobaali()"></app-prompti-versiovertailu>
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="sulje()">Sulje</button>
</mat-dialog-actions>
